
import { Vue, Prop, Component, Watch } from "vue-property-decorator";
import SchedulerItemAvatar from "@/components/scheduler/SchedulerItemAvatar.vue";
import CircleWithInitials from "@/components/card/CircleWithInitials.vue";
import RouteNames from "@/entities/RouteNames";
import RouteParams from "@/entities/RouteParams";
import ItemChipsWithMore from "@/components/common/ItemChipsWithMore.vue";
import ContainerSize from "@/components/uiSize/ContainerSize.vue";
import CardItemChipsContainer from "@/components/card/CardItemChipsContainer.vue";
import { Skill } from "@/generated/graphql";
import CardBodyItem from "@/components/card/CardBodyItem.vue";

@Component({
    components: {
        SchedulerItemAvatar,
        CircleWithInitials,
        ItemChipsWithMore,
        ContainerSize,
        CardItemChipsContainer,
        CardBodyItem,
    },
})
export default class EmployeeHoverCard extends Vue {
    @Prop({ type: Object, default: null }) readonly employee!: any;
    @Prop({ type: Boolean, default: false }) readonly isManager!: any;
    @Prop({ type: Number, default: 0 }) readonly projectsInprogress!: number;
    @Prop({ type: Number, default: 0 }) readonly projectsCompleted!: number;
    @Prop({ type: Array, default: null }) readonly projects!: any;
    @Prop({ type: Array, default: null }) readonly contractors!: any;
    @Prop({ type: Object, default: null }) readonly manager!: any;
    @Prop({ type: Array, default: [] }) readonly skills!: Skill[];

    //get first 3 contractors
    get firstContractors() {
        return this.contractors.slice(0, 3)
    }

    get firstProjects() {
        return this.projects.slice(0, 3)
    }

    get moreContractors() {
        return this.contractors.length > 3 ? this.contractors.length - 3 : 0
    }

    get moreProjects() {
        return this.projects.length > 3 ? this.projects.length - 3 : 0

    }

    get employeePageRouteParams(): RouteParams<{id: string}> {

      return {
        name: RouteNames.CONTRACTOR_DETAILS_ABOUT,
        params: {
          id: this.employee.id,
        },
      };
    }
}
